import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const MyPlannLoading = () => (
	<StyledCenteredStack spacing={2} px={5}>
		<RowSkeletonLoader />
		<RowSkeletonLoader />
		<RowSkeletonLoader />
	</StyledCenteredStack>
);
